import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { MAILTO } from '../../utils/mailto';
const HERO_IMAGE = "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/3zho3j7rbfxjzyaqujg3yf/eabcd6cc-4563-497d-b5b9-3dca6804fbf0/assets/home-hero.webp";
export function HeroDMRV() {
  return <section className="relative w-full overflow-hidden bg-white" data-id="element-981">
      <div className="relative z-[2] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36" data-id="element-982">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-983">
          {/* Left: Text */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-984">

            <motion.h1 className="text-[3.5rem] font-bold tracking-tight leading-[1.08] text-carbon-deep" initial="hidden" animate="visible" variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.12
              }
            }
          }} data-id="element-985">

              <motion.span className="block" variants={{
              hidden: {
                opacity: 0,
                y: 30
              },
              visible: {
                opacity: 1,
                y: 0,
                transition: {
                  duration: 0.6,
                  ease: [0.22, 1, 0.36, 1]
                }
              }
            }} data-id="element-986">
                Climate data infrastructure for African Businesses
              </motion.span>
            </motion.h1>

            <motion.p className="mt-6 text-lg sm:text-xl max-w-xl leading-relaxed text-carbon-deep/70" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.65,
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-987">

              Independent carbon accounting and dMRV platforms turning field
              data into verified climate impact.
            </motion.p>

            <motion.div className="mt-6 flex flex-wrap gap-3" initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.78,
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-988">

              <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-carbon-geo bg-white text-sm font-medium text-carbon-deep" data-id="element-989">
                <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-990" />
                EUDR Compliant
              </span>
              <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-carbon-geo bg-white text-sm font-medium text-carbon-deep" data-id="element-991">
                <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-992" />
                UCDA Certified
              </span>
              <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full border border-carbon-geo bg-white text-sm font-medium text-carbon-deep" data-id="element-993">
                <span className="w-2 h-2 rounded-full bg-carbon-bright" data-id="element-994" />
                Independent dMRV
              </span>
            </motion.div>

            <motion.div className="mt-10 flex flex-col sm:flex-row gap-4" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.85,
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-995">

              <a href={MAILTO.demo} className="inline-flex items-center gap-2.5 px-8 py-4 bg-carbon-bright text-carbon-deep text-base font-semibold rounded-lg hover:bg-carbon-light transition-colors shadow-lg shadow-carbon-bright/20" data-id="element-996">

                Book Demo
                <ArrowUpRightIcon className="w-4.5 h-4.5" data-id="element-997" />
              </a>
              <a href={MAILTO.expert} className="inline-flex items-center gap-2.5 px-8 py-4 border border-[#2d3c48] text-carbon-deep text-base font-semibold rounded-lg hover:bg-carbon-bright/5 transition-colors" data-id="element-998">

                Talk to Expert
                <ArrowUpRightIcon className="w-4.5 h-4.5" data-id="element-999" />
              </a>
            </motion.div>
          </motion.div>

          {/* Right: Image */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative" data-id="element-1000">

            <img src={HERO_IMAGE} alt="CarbonSafe platform dashboard showing verified climate data" className="w-full h-auto rounded-2xl" data-id="element-1001" />

          </motion.div>
        </div>
      </div>
      <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/3zho3j7rbfxjzyaqujg3yf/eabcd6cc-4563-497d-b5b9-3dca6804fbf0/foot-svg.svg" alt="" aria-hidden="true" className="absolute pointer-events-none select-none" data-id="element-973" style={{
      left: '83%',
      top: '75%',
      width: '80%',
      transform: 'translate(-50%, -50%) rotate(10deg)',
      opacity: 0.09
    }} />
    </section>;
}